import DottedReveal from "./DottedReveal";

export default function Main({image}) {
  
  return (
    <div style={{position: "relative"}}>
      <DottedReveal
        src={image}
        dotSize={6}
        gap={10}
        overlayColor="white"
        className="rounded-3"
        style={{          
          height: "30rem",
        }}
      ></DottedReveal>
      <div style={{
                position: "absolute",
                top: "52%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 4,
            }}>
              <img 
              className="img-fluid" src="/logos/bossblack.png"  alt="Middle Boss" />
            </div>
    </div>
  );
}
